import React from 'react';

import { cn } from '@/lib/utils';
import { LoaderCircle } from 'lucide-react';

type Props = {
  isLoading: boolean;
  children?: React.ReactNode;
  size?: number;
  className?: string;
  skeleton?: React.ReactNode;
  hasPreviousData?: boolean;
  avoidUnmount?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const Loading = ({ isLoading, children, size = 50, skeleton, hasPreviousData, className, avoidUnmount, ...props }: Props) => {
  if (avoidUnmount) return <div className={cn('relative', className)} {...props}>
    {children}
    <div className={cn("absolute top-0 flex h-full w-full items-center justify-center bg-gray-400/20 text-primary", isLoading ? 'absolute' : 'hidden')}>
      <span className="animate-spin">
        <LoaderCircle size={size} />
      </span>
    </div>
  </div>

  if (!isLoading) return <>{children}</>;

  if (skeleton && isLoading && !hasPreviousData) return <>{skeleton}</>;

  if (isLoading && hasPreviousData) return <>{children}</>;

  return (
    <div className={cn('relative', className)} {...props}>
      {children}
      <div className="absolute top-0 flex h-full w-full items-center justify-center bg-gray-400/20 text-primary">
        <span className="animate-spin">
          <LoaderCircle size={size} />
        </span>
      </div>
    </div>
  );
};

export default Loading;
